import type { ReactNode } from "react";
import { useFetchLegalPage, useFetchTermsAndConditionsStatus, useUpdateTermsAndConditionsStatus } from "@akina/infra";
import { LegalUpdateModal } from "./LegalUpdateModal";

type UpdatedTermsAcceptanceModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  app: "care" | "portal";
  entity: "patient" | "therapist";
  messages: { title: string; description: ReactNode; buttonLabel: string };
};

export function UpdatedTermsAcceptanceModal({
  open,
  onOpenChange,
  app,
  entity,
  messages,
}: Readonly<UpdatedTermsAcceptanceModalProps>) {
  const { data: legalPage } = useFetchLegalPage("terms-and-conditions", app);
  const { data: currentTerms } = useFetchTermsAndConditionsStatus(entity);
  const { mutate, isPending } = useUpdateTermsAndConditionsStatus({ onSuccess: () => onOpenChange(false) }, entity);

  function handleAccept() {
    if (!legalPage?.version || !currentTerms) return;
    mutate({
      termsAndConditionsAccepted: true,
      termsAndConditionsAcceptedTimestamp: new Date().toISOString(),
      dataPrivacyPolicyAccepted: currentTerms.dataPrivacyPolicyAccepted,
      dataPrivacyPolicyAcceptedTimestamp: currentTerms.dataPrivacyPolicyAcceptedTimestamp,
      privacyPolicyVersion: currentTerms.privacyPolicyVersion,
      termsVersion: legalPage.version,
    });
  }

  return (
    <LegalUpdateModal
      open={open}
      title={messages.title}
      description={messages.description}
      buttonLabel={messages.buttonLabel}
      isPending={isPending}
      onAccept={handleAccept}
    />
  );
}
